export default {
  methods: {
    stripEmoji(str) {
        return str.replace(/([\u2700-\u27BF]|[\uE000-\uF8FF]|\uD83C[\uDC00-\uDFFF]|\uD83D[\uDC00-\uDFFF]|[\u2011-\u26FF]|\uD83E[\uDD10-\uDDFF])/g,'').trim()
    },
    materialColorClass(str) {
      // Hash the text
      let hash = 0
      const paletteSize = 18
      str = this.stripEmoji(str)
      for (let i = 0; i < str.length; i++) {
        hash = (hash * 31 + str.charCodeAt(i)) >>> 0
      }
      const index = hash % paletteSize + 1
      return `material-color-${index}`
    }
  }
}